const ProgressBar = ({
  curTime,
  maxTime,
}: {
  curTime: number;
  maxTime: number;
}) => {
  const progressPercentage = (curTime / maxTime) * 100;

  return (
    <div className="relative pt-1">
      <div className="overflow-hidden h-4 mb-4 text-xs flex rounded bg-blue-200 dark:bg-slate-500">
        <div
          style={{ width: `${progressPercentage}%` }}
          className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-600 transition-all duration-500"
        />
      </div>
    </div>
  );
};

export default ProgressBar;
